/* src/app/acs-chat/components/message-input/message-input.scss */
:host {
  flex-shrink: 0;
}
.input-bar {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  background: #fff;
}
.input-field {
  flex: 1;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.4;
  outline: none;
  background: #fff;
  min-height: 40px;
  max-height: 120px;
  overflow-y: auto;
}
.input-field::placeholder {
  color: #aaa;
}
.input-field:focus {
  border-color: #5ba4b5;
}
.send-btn {
  background: #6abf69;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.send-btn:hover {
  background: #5aad59;
}
.send-btn:disabled {
  background: #c5e1c5;
  cursor: default;
}
/*# sourceMappingURL=message-input.css.map */
